var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 14.1787,
    cy: 15,
    rx: 14.1787,
    ry: 15,
    fill: "white",
    fillOpacity: 0.68
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2404_7989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3428 10.5001V18.4999C11.3427 18.5888 11.3667 18.6762 11.412 18.7529C11.4574 18.8297 11.5226 18.893 11.6009 18.9364C11.6792 18.9798 11.7677 19.0017 11.8574 18.9999C11.9471 18.998 12.0346 18.9725 12.111 18.9259L18.6645 14.926C18.7379 14.8813 18.7986 14.8186 18.8406 14.744C18.8827 14.6695 18.9047 14.5854 18.9047 14.5C18.9047 14.4146 18.8827 14.3305 18.8406 14.256C18.7986 14.1814 18.7379 14.1187 18.6645 14.074L12.111 10.0741C12.0346 10.0275 11.9471 10.002 11.8574 10.0001C11.7677 9.99825 11.6792 10.0202 11.6009 10.0636C11.5226 10.107 11.4574 10.1703 11.412 10.2471C11.3667 10.3238 11.3427 10.4112 11.3428 10.5001Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2404_7989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3429,
    height: 12,
    fill: "white",
    transform: "translate(8.50684 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.1de6730d7943bb6c3d7f52d10144d79d.svg";
export { ForwardRef as ReactComponent };